export default __webpack_public_path__ + "d4b587571c9c393e1f1a895896a914b4.svg";